import { render, staticRenderFns } from "./Form8CaseInformation.vue?vue&type=template&id=720db2df&scoped=true"
import script from "./Form8CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form8CaseInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720db2df",
  null
  
)

export default component.exports